import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Tooltip, TooltipProps } from "@material-ui/core";
import React from "react";

const useTooltipHoverStyles = makeStyles(() => ({
  tooltipHover: {
    cursor: "pointer",
    padding: "0.25rem 0.4rem",
    borderRadius: "0.5rem",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)",

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
}));

const InfoTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#ffffff",
    color: "#000000",
    border: "0.0625rem solid",
  },
}))(Tooltip) as React.ComponentType<TooltipProps>;

export { useTooltipHoverStyles, InfoTooltip };
